import './bostonburgercompany/style';
import FormStructure from './bostonburgercompany/form_structure';

export default FormStructure;